var jqA = jQuery.noConflict();
var jEditor;
var mesures = {
    default: {
        transform: 1,
        unit: 'cm'
    },
    US: {
        transform: 2.54,
        unit: '"'
    }
};

function setcookie(cookieName, cookieValue) {
    var today = new Date();
    var expire = new Date();
    expire.setTime(today.getTime() + 3600000 * 24 * 15);
    document.cookie = cookieName + "= " + btoa(cookieValue) + ";expires=" + expire.toGMTString();
}


function cropdataURL(datas, bound) {
    return new Promise(function (resolve, reject) {
        var img = document.createElement('img');
        img.src = datas;
        img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            canvas.width = bound[2];
            canvas.height = bound[3];

            ctx.drawImage(img, bound[0], bound[1], bound[2], bound[3], 0, 0, bound[2], bound[3]);

            var dataURI = canvas.toDataURL();
            jqA('body').append(canvas)
            resolve(dataURI);
        };
    })
};

function tranlsateMesure(x, country) {
    let unit;
    if (country in mesures) {
        unit = mesures[country];
    } else {
        unit = mesures['default'];
    }
    return (parseFloat(x) / unit.transform).toFixed(0) + unit.unit;
};

function tranlsateMesureGroup(x) {
    return tranlsateMesure(x[0], DomainCode) + " x " + tranlsateMesure(x[1], DomainCode);
};


function resizedataDataCanvas(datas, wantedWidth, wantedHeight) {
    return new Promise(function (resolve, reject) {
        var img = document.createElement('img');
        img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            canvas.width = wantedWidth;
            canvas.height = wantedHeight;
            ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
            var dataURI = canvas.toDataURL();
            resolve(dataURI);
        };
        img.src = datas;
    })
};

(function () {

    'use strict';

    angular.module('FotocApp', ['ngTouch', 'angularRipple', 'angular-carousel'])
        .constant('CONSTANTS',
            {
                "CANVAS_WIDTH": 1000,
                "CANVAS_HEIGHT": 1000,
                "BASE_PATH": window.BASE_PATH,
                "WEB_PATH": window.WEB_PATH,
                "VERSION": '2.5.0'
            });

    jEditor = jqA("editor");
    if (typeof (jEditor) !== 'undefined' && jEditor.length > 0) {

        var Editor = {

            setImage: function ($json_item_mygalery) {

                var $editorService = jEditor.scope().$editorService;
                var $canvasService = jEditor.scope().$canvasService;
                $editorService.data.images[0] = {
                    type: 'my_galery', data: $json_item_mygalery,
                    urlWithoutFilter: $json_item_mygalery.cdnUrl,
                    frameColor: $editorService.ui.lastFrameColorSelected,
                    position: {}
                }
                $canvasService.setImage($json_item_mygalery.cdnUrl);
                $editorService.setCacheImages($json_item_mygalery.cdnUrl);

                jqA("#guardar_button").removeAttr("disabled");
            },

            preloadImage: function (url) {
                var $editorService = jEditor.scope().$editorService;

                const regex = /\.com\/([\w-]*)\//gm;
                let m;
                let uuid;

                while ((m = regex.exec(url)) !== null) {
                    if (m.index === regex.lastIndex) {
                        regex.lastIndex++;
                    }
                    m.forEach((match, groupIndex) => {
                        if (groupIndex === 1) {
                            uuid = match;
                        }
                    });
                }
                /*
                                var data = {
                                    type: 'my_galery', data: {
                                        cdnUrl: url,
                                        cdnUrlModifiers: null,
                                        crop: undefined,
                                        isImage: true,
                                        isStored: true,
                                        //metadata: {},
                                        //mimeType: "image/jpeg",
                                        //name: "X.JPG",
                                        originalUrl: url,
                                        originalVideoInfo: null,
                                        sourceInfo: { source: 'local', file: File },
                                        uuid: uuid,
                                    },
                                    urlWithFilter: url + "-/resize/1024/",
                                    urlWithoutFilter: url + "-/resize/1024/",
                                    frameColor: $editorService.ui.lastFrameColorSelected,
                                    position: {}
                                };*/

                var data = {
                    cdnUrl: url,
                    cdnUrlModifiers: null,
                    crop: undefined,
                    isImage: true,
                    isStored: true,
                    //metadata: {},
                    //mimeType: "image/jpeg",
                    //name: "X.JPG",
                    originalUrl: url,
                    originalVideoInfo: null,
                    sourceInfo: { source: 'local', file: File },
                    uuid: uuid,
                };

                $editorService.ui.my_galery.push({ id: -1 })

                setTimeout(function () {
                    $editorService.ui.toolOpen = 'images';
                    jEditor.scope().$apply();
                }, 0);

                $editorService.ui.my_galery = $editorService.ui.my_galery.filter(function (item) {
                    return !(item.id === -1);
                });
                $editorService.ui.my_galery.push(data);
                setcookie('fotoc_my_galery', JSON.stringify($editorService.ui.my_galery));
                this.selectImage(data, 'my_galery', false);
            },

            /**
                 * SelectImage form Controls!!! 
                 * 
                 * @param {*} $data 
                 * @param {*} $type 
                 * @param {*} $indexFromImageGalery 
                 */
            selectImage: function ($data, $type, $indexFromImageGalery) {
                var $editorService = jEditor.scope().$editorService;
                var $canvasService = jEditor.scope().$canvasService;

                switch ($type) {

                    case "my_galery":

                        var u = $data.cdnUrl + ($data.fotocOwner ? '' : '-/resize/1024/');
                        var _editingItem = $editorService.ui.editingItem;

                        if ($editorService.ui.compositionsAsGroup) {

                            $editorService.ui.view = { type: 'edit', id: null };
                            if ($indexFromImageGalery === false) {
                                $editorService.data.images.push({
                                    type: 'my_galery',
                                    frameColor: $editorService.ui.lastFrameColorSelected,
                                    data: $data,
                                    urlWithoutFilter: u,
                                    urlWithFilter: u,
                                    position: { x: 500, y: 500, rotation: 0, scaleX: 1, scaleY: 1 },
                                    userForce: true
                                });
                            }

                            var pos_in_images = false;
                            var cant = $editorService.data.images.length;
                            for (var i = 0; i < cant; i++) {
                                if ($editorService.data.images[i].data.uuid === $data.uuid) {
                                    pos_in_images = i;
                                }
                            }

                            if (pos_in_images !== false) {
                                $editorService.ui.editingItem = pos_in_images;
                            }

                        } else {
                            $editorService.data.images[_editingItem] = {
                                type: 'my_galery',
                                frameColor: $editorService.ui.lastFrameColorSelected,
                                data: $data,
                                urlWithoutFilter: u,
                                urlWithFilter: u,
                                position: {},
                                userForce: true
                            }

                            $canvasService.setImage(u, true, _editingItem, false)
                            $editorService.setCacheImages(u);
                        }

                        break;

                    case "stock":

                        var extract_url = $editorService.extract_preview_url($data.assets.preview.url, $data.assets.preview.width, $data.assets.preview.height);
                        $editorService.data.images[$editorService.ui.editingItem] = {
                            type: 'stock',
                            data: $data,
                            frameColor: $editorService.ui.lastFrameColorSelected,
                            urlWithoutFilter: extract_url,
                            position: {},
                            userForce: true
                        }
                        $canvasService.setImage(extract_url, true, $editorService.ui.editingItem, false);
                        $editorService.setCacheImages($data.assets.large_thumb.url);

                        break;
                }
            },

            setStockImage: function ($data) {

                var $editorService = jEditor.scope().$editorService;
                var $canvasService = jEditor.scope().$canvasService;

                //var extract_url = $editorService.extract_preview_url($data.assets.preview.url, $data.assets.preview.width, $data.assets.preview.height);
                $editorService.data.images[$editorService.ui.editingItem] = {
                    type: 'stock',
                    data: $data,
                    frameColor: $editorService.ui.lastFrameColorSelected,
                    urlWithoutFilter: $data.assets.huge_thumb.url,
                    position: {},
                    userForce: true
                }
                $canvasService.setImage($data.assets.huge_thumb.url, true, $editorService.ui.editingItem, false, true, ($data.assets.huge_thumb.width + "x" + ($data.assets.huge_thumb.height - 20)), true);
                $editorService.setCacheImages($data.assets.huge_thumb.url);

                jqA("#guardar_button").removeAttr("disabled");
            },

            getData: function () {
                var data = Object.assign({}, jEditor.scope().$editorService.data);
                if (!jEditor.scope().$editorService.ui.returnAllSelectedImages) {
                    data.images = data.images.slice(0, jEditor.scope().$editorService.getLayout().bounds.length || 1);
                }
                data.images = data.images.map(function (image) {

                    var ret = image;
                    if (image.type === 'stock') {
                        image.data = {
                            id: image.data.id,
                            assets: {
                                large_thumb: image.data.assets.large_thumb
                            }
                        }
                    }
                    return ret;
                });
                return data
            },

            setData: function ($data) {

                $data.group = parseInt($data.group);
                jEditor.scope().$editorService.data = $data;
                jEditor.scope().$canvasService.makeFromData();
                jEditor.scope().$apply();
            },

            setEditorType: function (type) {
                window.TYPE_EDITOR = type;
                if (jEditor.length && jEditor.scope() !== undefined && jEditor.scope().$editorService !== undefined) {
                    jEditor.scope().$editorService.initConfig(type);
                    jEditor.scope().$canvasService.init();
                    jEditor.scope().$editorService.initLayout();
                    jEditor.scope().$canvasService.makeFromData();
                    jEditor.scope().$apply();
                }
            },

            getPreview: function () {
                return jqA("editor").scope().$canvasService.getSnapshot(true);
            },

            getFramesPreviews: function ($tilesPaging) {
                if (!jqA("editor").scope().$editorService.ui.compositionsAsGroup) {
                    return new Promise(function (resolve, reject) {
                        var bounds = jEditor.scope().$editorService.getLayout().bounds;
                        var snapshot = jEditor.scope().$canvasService.getSnapshot();
                        var promises = [];

                        bounds.forEach(function ($bound) {
                            promises.push(cropdataURL(snapshot, $bound))
                        });

                        Promise.all(promises).then(function (values) {
                            resolve(values);
                        })


                    });
                } else {

                    return new Promise(function (resolve, reject) {

                        var images = jqA("editor").scope().$editorService.data.images;
                        if (typeof $tilesPaging != 'undefined') {
                            images = images.slice($tilesPaging[0], $tilesPaging[1])
                        }

                        var promises = [];
                        images.forEach(function ($bound, index) {
                            var snapshot = jqA("editor").scope().$canvasService.getSnapshotTile(index);
                            promises.push(
                                resizedataDataCanvas(snapshot, 200, 200)
                            );
                        });

                        Promise.all(promises).then(function (values) {
                            resolve(values);
                        });
                    });
                }

            },

            updatePrice: function () {
                jqA("editor").scope().$apply();
            },

            clickOnCustomUploadButton: function () {
                var $editorService = jEditor.scope().$editorService;
                var $tutorialService = jEditor.scope().$tutorialService;

                if (window.browserInfo !== undefined && window.browserInfo.mobile) {
                    if (window.browserInfo.os === 'ios') {
                        if (window.browserInfo.browser === 'facebook') {
                            return $tutorialService.showSlideOSFacebook();
                        } else if (window.browserInfo.browser === 'instagram') {
                            return $tutorialService.showSlideOSInstagram();
                        }
                    } else if (window.browserInfo.os === 'android') {
                        if (window.browserInfo.browser === 'facebook') {
                            return $tutorialService.showSlideAndroidFacebook();
                        } else if (window.browserInfo.browser === 'instagram') {
                            return $tutorialService.showSlideAndroidInstagram();
                        }
                    }
                }
                $editorService.uploadCare.value(null);
                $editorService.uploadCare.openDialog();
                var $editorService = jEditor.scope().$editorService;
                $editorService.hideTools();
            }

        };
        window.Editor = Editor;

        // Load gallery:
        setTimeout(function () {
            var url = new URL(window.location.href);
            var options = url.searchParams.getAll("gallery[]");
            if (options.length > 0) {
                var $editorService = jEditor.scope().$editorService;
                var $canvasService = jEditor.scope().$canvasService;

                $canvasService.closeTutorial();
                $editorService.ui.my_galery = [];

                options.forEach(function (v, i) {
                    Editor.preloadImage(v);
                });
            }
        }, 3000);
    }

})(); 